var infraestructuras = angular.module('chatbox', []);

infraestructuras.controller(
    'chatboxController',
    [
        '$scope',
        '$q',
        'chatboxService',
        function ($scope, $q, chatboxService) {

            $scope.messages = [];
            $scope.newMessage = '';
            $scope.conversationId = '';

            $scope.showChatbox = false;
            $scope.showAyuda = true;
            $scope.isSending = false;
            $scope.isCreatingConversation = false;

            $scope.messages.push({
                sender: 'system',
                text: 'Soy el Inspector Virtual, el asistente de inspecciones ferroviarias.',
                timestamp: new Date()
            });

            $scope.messages.push({
                sender: 'system',
                text: '¿En qué puedo ayudarte?',
                timestamp: new Date()
            });

            function getErrorMessage(error) {
                if (error && error.data && error.data.error) {
                    return error.data.error;
                }

                if (error && error.data && typeof error.data === 'string') {
                    return error.data;
                }

                return 'No se pudo conectar con el servicio de asistencia.';
            }

            function addSystemMessage(text) {
                $scope.messages.push({
                    sender: 'system',
                    text: text,
                    timestamp: new Date()
                });
            }

            function ensureConversation() {
                if ($scope.conversationId) {
                    return $q.when($scope.conversationId);
                }

                if ($scope.isCreatingConversation) {
                    return $q.reject({
                        data: {
                            error: 'La conversación se está inicializando.'
                        }
                    });
                }

                $scope.isCreatingConversation = true;

                return chatboxService.createConversation()
                    .then(function (response) {
                        var data = response.data || {};

                        $scope.conversationId =
                            data.conversationId ||
                            data.response ||
                            '';

                        if (!$scope.conversationId) {
                            return $q.reject({
                                data: {
                                    error: 'El servidor no devolvió un identificador de conversación.'
                                }
                            });
                        }

                        return $scope.conversationId;
                    })
                    .finally(function () {
                        $scope.isCreatingConversation = false;
                    });
            }

            $scope.sendMessage = function () {
                if ($scope.isSending) {
                    return;
                }

                var message = ($scope.newMessage || '').trim();

                if (!message) {
                    return;
                }

                $scope.messages.push({
                    sender: 'user',
                    text: message,
                    timestamp: new Date()
                });

                $scope.newMessage = '';
                $scope.isSending = true;

                ensureConversation()
                    .then(function (conversationId) {
                        return chatboxService.sendInspectorVirtualMessage(
                            //return chatboxService.sendInspectorForalMessage(
                            message,
                            conversationId
                        );
                    })
                    .then(function (response) {
                        var answer = response.data &&
                            response.data.response
                            ? response.data.response
                            : '';

                        if (answer && answer.trim()) {
                            addSystemMessage(answer);
                        } else {
                            addSystemMessage(
                                'El asistente no devolvió contenido.'
                            );
                        }
                    })
                    .catch(function (error) {
                        console.error(
                            'Error al obtener respuesta del chatbox:',
                            error
                        );

                        addSystemMessage(getErrorMessage(error));
                    })
                    .finally(function () {
                        $scope.isSending = false;
                    });
            };

            $scope.mostrarChatBox = function () {
                $scope.showChatbox = true;
                $scope.showAyuda = false;

                ensureConversation()
                    .catch(function (error) {
                        console.error(
                            'Error al crear la conversación:',
                            error
                        );

                        addSystemMessage(getErrorMessage(error));
                    });
            };

            $scope.mostrarAyuda = function () {
                $scope.showChatbox = false;
                $scope.showAyuda = true;
            };
        }
    ]
);